import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CookieService } from 'ngx-cookie';
import { UserService } from '../services/user.service';
import * as _ from 'underscore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-model',
  templateUrl: './usermodels.component.html',
  styleUrls: ['./models.component.css']
})
export class UserModelComponent implements OnInit {
  loading = false;
  users = [];
  selectedUser: any = '';
  hasError: any;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef
    , private cookieService: CookieService
    , private userService: UserService) {

  }

  ngOnInit() {
  this.loading = true;
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      this.userService.getMonitoringUsers(user).subscribe(
      response => {
        this.users = response;
        console.log(this.users);
        this.loading = false;
      }, err => {
          console.log('Can not get list of users in popup.');
      }
    );
    } catch (err) {
      console.log('Error generated UserModelComponent:constructor()' + err);
      this.loading = false;
    }
  }

  onUserSelect(user: any) {
    this.selectedUser = user;
    this.event.emit({user: this.selectedUser});
  }
}

@Component({
  selector: 'app-sensor-model',
  templateUrl: './sensormodels.component.html',
  styleUrls: ['./models.component.css']
})
export class SensorModelComponent implements OnInit {
  input: any;
	selectionModel = {};
	allSelected = true;
	streamGroups = [];

  streams: any;
  devices:  any;
  settings:  any;
  categoryLabels: any;
  hideDisabledStreams: false;
  hasStreamsToDisplay: false;
  selectedDevice: any;

  multipleSignalsForm: any = {};



  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef
      , private cookieService: CookieService
      , private userService: UserService,
      private formBuilder: FormBuilder, ) {

        this.multipleSignalsForm = this.formBuilder.group({

        });
  }

  ngOnInit() {
    for (let i = 0, len = this.streams.length; i < len; i++) {
      const stream = this.streams[i];
      this.selectionModel[stream.id] = this.settings.chart[stream.id].selected;

      if ((this.hideDisabledStreams
          && stream.enabled == false) || (this.selectedDevice != null && stream.deviceId != this.selectedDevice.id)) {
          return; // continue
      }

      let deviceGroup = this.streamGroups[stream.deviceId];
			if (!deviceGroup) {
				deviceGroup = {
						device: this.resolveDevice(stream.deviceId),
						categories: {}
				};
				this.streamGroups.push(deviceGroup);
			}
      console.log('streamGroups');
      console.log(this.streamGroups);

      const displayCategoryName = this.categoryLabels[stream.dataStreamType.category];
			let categoryGroup = deviceGroup.categories[displayCategoryName];
			if (!categoryGroup) {
				categoryGroup = {
					streams: []
				};
				deviceGroup.categories[displayCategoryName] = Array.of(categoryGroup);
			}
			categoryGroup.streams.push(stream);
    }

    this.updateSelectAllStreams(true);

  }

  updateSelectAllStreams(defaultValue) {
    defaultValue = defaultValue === true || false;
		let checkedFound = false;
		let uncheckedFound = false;
    for (let i = 0; i < this.streams.length; i++) {
			const device = this.resolveDevice(this.streams[i].deviceId);
			if (device || (this.hideDisabledStreams &&
						this.streams[i].enabled == false)) {
					continue;
			}

			const streamId = this.streams[i].id;
			const isChecked = this.selectionModel[streamId] ;

			checkedFound = checkedFound || isChecked;
			uncheckedFound = uncheckedFound || !isChecked;

			if (checkedFound && uncheckedFound) {
					break;
			}
      // all checked
			if (uncheckedFound == false) {
				this.allSelected = true;
				if (this.multipleSignalsForm) {
					this.multipleSignalsForm.setValue('validForm', this.allSelected);
				}
			} else if (checkedFound == false) {
			  this.allSelected = false;
			  if (this.multipleSignalsForm) {
				  this.multipleSignalsForm.setValue('validForm', this.allSelected);
			  }

		  } else {
			  this.allSelected = defaultValue;
		  }
		}
  }

  selectAllStreams() {
		this.allSelected = !this.allSelected;
		if (this.multipleSignalsForm) {
			this.multipleSignalsForm.setValue('validForm', this.allSelected);
		}

		for (let i = 0; i < this.streams.length; i++) {
			if (this.hideDisabledStreams &&
						this.streams[i].enabled == false) {
					continue;
			}

		const streamId = this.streams[i].id;
		}
	}


    resolveDevice(deviceId) {
        /*return _.find(this.devices, function (device) {
            if( deviceId === device['id']){
                return device;
            }
        });*/
        this.devices.find(function(device) {
            if( deviceId === device['id']) {
                return device;
            }
        });
        return null;
    }

  onUserSelect(user: any) {

  }
}
